import { render, staticRenderFns } from "./VisibleHeadersModal.vue?vue&type=template&id=1c3580a4"
import script from "./VisibleHeadersModal.vue?vue&type=script&lang=js"
export * from "./VisibleHeadersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Tables/VisibleHeadersModal.vue
// module id = 1487
// module chunks = 31